module.exports = __webpack_public_path__ + "img/imgZXGH(3).00335980.png";